"use strict";

const _console = console,
      log = _console.log;
module.exports = log;